export const READER_TIERS = [
  {
    id: 'FIRST_PAGE',
    label: 'First Page',
    level: 0,
    minXP: 0,
    maxXP: 300,
    color: '#94a3b8',
    gradient: 'linear-gradient(135deg, #94a3b8, #cbd5e1)',
    ringColor: '#94a3b8',
    icon: 'N',
    ringClass: 'ring-reader-1',
    requirement: "Every legend begins with a single turned page. You stand at the mountain's foot, where the first story calls your name and the wind carries the scent of a thousand unread worlds. Take your first step — read, comment, review — and the mountain will open its path.",
  },
  {
    id: 'PAGE_TURNER',
    label: 'Page Turner',
    level: 1,
    minXP: 300,
    maxXP: 1500,
    color: '#14b8a6',
    gradient: 'linear-gradient(135deg, #14b8a6, #2dd4bf)',
    ringColor: '#14b8a6',
    icon: 'R',
    ringClass: 'ring-reader-2',
    requirement: "The trail steepens and the pages turn of their own accord. You have tasted the addiction of the cliffhanger, the ache of the final chapter. Seventy-five chapters lie behind you — each a stone on the path. The mountain knows your name now.",
  },
  {
    id: 'NIGHT_OWL',
    label: 'Night Owl',
    level: 2,
    minXP: 1500,
    maxXP: 5000,
    color: '#3b82f6',
    gradient: 'linear-gradient(135deg, #3b82f6, #60a5fa)',
    ringColor: '#3b82f6',
    icon: 'AR',
    ringClass: 'ring-reader-3',
    requirement: "You read by moonlight when the world sleeps. Three hundred and seventy-five chapters have passed through your hands, and your words — comments sharp as owl talons, reviews wise as the old moon — earn the community's upvotes. The night is your kingdom, and the stars are your witnesses.",
  },
  {
    id: 'BINGE_VOYAGER',
    label: 'Binge Voyager',
    level: 3,
    minXP: 5000,
    maxXP: 12000,
    color: '#8b5cf6',
    gradient: 'linear-gradient(135deg, #8b5cf6, #a78bfa)',
    ringColor: '#8b5cf6',
    icon: 'S',
    ringClass: 'ring-reader-4',
    requirement: 'You have sailed past one thousand two hundred and fifty chapters — a voyager on seas of story, charting constellations no map has named. Your contributions ripple through the community like waves, and the reception of your words builds like a tide. Few dare sail this far.',
  },
  {
    id: 'STORY_HUNTER',
    label: 'Story Hunter',
    level: 4,
    minXP: 12000,
    maxXP: 30000,
    color: '#ec4899',
    gradient: 'linear-gradient(135deg, #ec4899, #f472b6)',
    ringColor: '#ec4899',
    icon: 'SG',
    ringClass: 'ring-reader-5',
    requirement: 'Three thousand chapters stalked and claimed. You hunt stories through the dense forests of the library, and your reviews are trophies hung on the community\'s wall. The mountain\'s upper slopes are visible now — cold, thin, and reserved for the relentless.',
  },
  {
    id: 'LORE_KEEPER',
    label: 'Lore Keeper',
    level: 5,
    minXP: 30000,
    maxXP: 75000,
    color: '#f59e0b',
    gradient: 'linear-gradient(135deg, #f59e0b, #fbbf24)',
    ringColor: '#f59e0b',
    icon: 'LD',
    ringClass: 'ring-reader-6',
    requirement: 'Seven thousand five hundred chapters — a hoard that would shame any dragon. You are a keeper of lore, a living archive whose every review and discussion shapes the community\'s canon. Legends speak of you in the present tense. The summit glitters above, close enough to touch.',
  },
  {
    id: 'GRAND_ARCHIVIST',
    label: 'Grand Archivist',
    level: 6,
    minXP: 75000,
    maxXP: Infinity,
    color: '#e11d48',
    gradient: 'linear-gradient(135deg, #e11d48, #fb7185)',
    ringColor: '#e11d48',
    icon: 'MB',
    ringClass: 'ring-reader-7',
    requirement: 'The summit. The air is thin and the sky is close. You have read what no mortal has read, and your voice is the final word — the most trusted in all the community. You are the Grand Archivist, and the mountain itself bows. This is legend. This is forever.',
  },
];

export const WRITER_TIERS = [
  {
    id: 'FIRST_DRAFT',
    label: 'First Draft',
    level: 0,
    minXP: 0,
    maxXP: 500,
    color: '#94a3b8',
    gradient: 'linear-gradient(135deg, #94a3b8, #cbd5e1)',
    ringColor: '#94a3b8',
    icon: 'Sc',
    ringClass: 'ring-writer-1',
    requirement: 'Every saga begins with a trembling hand and a blank page. You publish your first chapter — a spark struck in the dark, a voice raised for the first time. The mountain hears you. The ink is wet, the path is born, and the journey of a million words starts with this one.',
  },
  {
    id: 'INKSTAIN',
    label: 'Inkstain',
    level: 1,
    minXP: 500,
    maxXP: 2500,
    color: '#0ea5e9',
    gradient: 'linear-gradient(135deg, #0ea5e9, #38bdf8)',
    ringColor: '#0ea5e9',
    icon: 'IA',
    ringClass: 'ring-writer-2',
    requirement: 'Thirty-seven thousand words stain your fingers — the mark of a writer who has stopped dabbling and started bleeding onto the page. Readers begin to bookmark your work, to rate your worlds. The ink has seeped into your skin. There is no going back to the life before stories.',
  },
  {
    id: 'QUILL_WIELDER',
    label: 'Quill Wielder',
    level: 2,
    minXP: 2500,
    maxXP: 8000,
    color: '#10b981',
    gradient: 'linear-gradient(135deg, #10b981, #34d399)',
    ringColor: '#10b981',
    icon: 'St',
    ringClass: 'ring-writer-3',
    requirement: 'Nearly two hundred thousand words — and the quill is no longer a tool but an extension of your hand. Your novels gather bookmarks, ratings, and reviews like a gathering storm. You wield words with intent now, each chapter a deliberate stroke. The mountain\'s midpoint is yours.',
  },
  {
    id: 'CHAPTER_CRAFTER',
    label: 'Chapter Crafter',
    level: 3,
    minXP: 8000,
    maxXP: 20000,
    color: '#f97316',
    gradient: 'linear-gradient(135deg, #f97316, #fb923c)',
    ringColor: '#f97316',
    icon: 'W',
    ringClass: 'ring-writer-4',
    requirement: 'Six hundred thousand words — each chapter a crafted thing, a stone fitted into a cathedral of story. Your reader base grows like a forest, roots deepening with every update. You no longer write chapters; you forge them. The air thins. The summit beckons.',
  },
  {
    id: 'WORLD_FORGER',
    label: 'World Forger',
    level: 4,
    minXP: 20000,
    maxXP: 50000,
    color: '#f43f5e',
    gradient: 'linear-gradient(135deg, #f43f5e, #fb7185)',
    ringColor: '#f43f5e',
    icon: 'NS',
    ringClass: 'ring-writer-5',
    requirement: 'One and a half million words. You do not write stories — you forge worlds. Continents of prose, oceans of dialogue, mountain ranges of plot. Your readers inhabit the realms you hammer into being, and their bookmarks are the flags of nations. Few smiths reach this anvil.',
  },
  {
    id: 'VOICE_OF_AN_ERA',
    label: 'Voice of an Era',
    level: 5,
    minXP: 50000,
    maxXP: 120000,
    color: '#6366f1',
    gradient: 'linear-gradient(135deg, #6366f1, #818cf8)',
    ringColor: '#6366f1',
    icon: 'EA',
    ringClass: 'ring-writer-6',
    requirement: 'Three and three-quarter million words. Your voice does not merely speak — it defines an era. Generations of readers will measure their stories against yours. The community speaks your name in reverence. The summit is a breath away, wreathed in cloud and legend.',
  },
  {
    id: 'INK_IMMORTAL',
    label: 'Ink Immortal',
    level: 6,
    minXP: 120000,
    maxXP: Infinity,
    color: '#e11d48',
    gradient: 'linear-gradient(135deg, #e11d48, #fb7185)',
    ringColor: '#e11d48',
    icon: 'GS',
    ringClass: 'ring-writer-7',
    requirement: 'The summit. The ink has become blood and the blood has become legend. Nine million words — a monument that will outlast the mountain itself. You are the Ink Immortal. Your stories will be read when the stars are ash. This is the peak. This is forever.',
  },
];

// Backward-compatible TIERS (reader tiers as default)
export const TIERS = READER_TIERS;

const TIER_MAPS = {
  READER: READER_TIERS,
  WRITER: WRITER_TIERS,
};

export const getTiers = (track = 'READER') => TIER_MAPS[track] || READER_TIERS;

export const getTierByXP = (xp, track = 'READER') => {
  const tiers = getTiers(track);
  for (let i = tiers.length - 1; i >= 0; i--) {
    if (xp >= tiers[i].minXP) return tiers[i];
  }
  return tiers[0];
};

export const getTierById = (tierId, track = 'READER') => {
  const tiers = getTiers(track);
  return tiers.find((t) => t.id === tierId) || tiers[0];
};

export const getNextTier = (tierId, track = 'READER') => {
  const tiers = getTiers(track);
  const idx = tiers.findIndex((t) => t.id === tierId);
  if (idx < 0 || idx >= tiers.length - 1) return null;
  return tiers[idx + 1];
};

export const getProgressToNextTier = (xp, tierId, track = 'READER') => {
  const tier = getTierById(tierId, track);
  const next = getNextTier(tierId, track);
  if (!next) return 1.0;
  const range = tier.maxXP - tier.minXP;
  if (range <= 0) return 1.0;
  return Math.min(1.0, Math.max(0.0, (xp - tier.minXP) / range));
};
